module.exports = __webpack_public_path__ + "img/evaluateImg05.4ae6b741.png";